import React from "react"
import {
    School,
    AddLinkOutlined,
    PaymentOutlined,
    DesignServicesOutlined,
    SettingsOutlined
} from "@mui/icons-material"
import { SectionLayout } from "../components/index"

const NAV_SECTIONS = [
    {
        title: "Institution",
        items: [
            {
                name: "Institution Setting",
                description: "Profile, details and members",
                to: "platform",
                icon: <School />
            }
        ]
    },
    {
        title: "Academics",
        items: [
            {
                name: "Create Registration Link",
                description: "Share admission forms with students",
                to: "student_registration",
                icon: <AddLinkOutlined />
            },
            {
                name: "Fee Setting",
                description: "Fee structure for each class",
                to: "fee_structure",
                icon: <PaymentOutlined />
            },
            {
                name: "Certificate Templates",
                description: "Choose certificate designs",
                to: "certificate_template",
                icon: <DesignServicesOutlined />
            }
        ]
    }
]

const StackLayer = () => (
    <SectionLayout
        basePath="/setting"
        title="Settings"
        subtitle="Your institution"
        icon={<SettingsOutlined />}
        sections={NAV_SECTIONS}
        collapseStorageKey="settings_sidebar_collapsed"
    />
)

export default StackLayer
